import { CloudApplliances } from './CloudApplliances';

const ca = new CloudApplliances();
(window as any).ca = ca;